// Ranh giới phiên ở lớp app: dữ liệu trong QueryClient thuộc về người đang đăng nhập (service đã lọc theo phạm vi của
// họ) ⇒ phiên mới trên cùng tab (đăng nhập lại / người khác) không được thấy cache của phiên trước.
import { useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { stopRealtime } from '@/shared/api';
import { session, type SessionStatus } from '@/entities/session';
import { resetUserCache } from './query';

/**
 * - Vào 'authenticated' sau một trạng thái đã biết (đăng nhập / đăng ký / tạo công ty trên màn đăng nhập) ⇒ xoá cache
 *   trước khi route `authed` nạp bootstrap ⇒ bootstrap, Tìm nhanh, hộp việc… được tải lại cho đúng người.
 *   Không xoá lúc 'anonymous': khung ứng dụng của phiên cũ có thể vẫn đang hiển thị trong lúc chuyển trang (useViewer
 *   cần bootstrap) — dữ liệu cũ chỉ nằm trong bộ nhớ, không hiển thị ở màn đăng nhập.
 * - Vào 'anonymous' (đăng xuất / phiên hết hạn giữa chừng) ⇒ đóng kênh thời gian thực.
 */
export function useSessionBoundary() {
  const qc = useQueryClient();
  useEffect(() => {
    let prev: SessionStatus = session.status;
    const off = session.subscribe(() => {
      const next = session.status;
      if (next === 'anonymous') stopRealtime();
      if (next === 'authenticated' && prev !== 'unknown') resetUserCache(qc);
      prev = next;
    });
    return () => void off();
  }, [qc]);
}
